// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"07b2469f","517":"949d62c5","569":"258dcc58","612":"a6d38799","787":"0b0b87eb","810":"0927d833","888":"d57df8d4"}[chunkId] + ".chunk.js";
};